import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { useToast } from '@react-aria/toast';
import { useRef } from 'react';
import { PlainButton } from '../../buttons/PlainButton/PlainButton.js';
import { LoadingIcon } from '../../icons/LoadingIcon.js';
import { XIcon } from '../../icons/XIcon.js';
import { twMerge } from '../../utils/twMerge.js';
export function Toast({ state, ...props }) {
    const ref = useRef(null);
    const { toastProps, contentProps, titleProps, closeButtonProps } = useToast(props, state, ref);
    const { animation, key } = props.toast;
    const { isCloseable, isLoading, variant, description } = props.toast.content;
    const handleAnimationEnd = () => {
        if (animation === 'exiting') {
            state.remove(key);
        }
    };
    return (_createElement("div", { ...toastProps, key: key, ref: ref, onAnimationEnd: handleAnimationEnd, className: twMerge('ppl-Toast m-2 flex max-w-sm items-center justify-between gap-4 rounded bg-inverse p-4 text-inverse-default shadow-md transition-all', animation === 'entering' && 'animate-toast-slide-in', animation === 'queued' && 'animate-toast-fade-in', animation === 'exiting' && 'animate-toast-slide-out', variant === 'error' && 'bg-critical-bold'), "data-animation": animation },
        isLoading ? (_jsx(LoadingIcon, { className: "animate-spin text-inverse-default transition-opacity motion-reduce:animate-none", "aria-label": "Loading" })) : null,
        _jsx("div", { ...contentProps, children: _jsx("div", { ...titleProps, children: description }) }),
        isCloseable ? (_jsx(PlainButton, { variant: "inverse", type: "button", ...closeButtonProps, onPress: closeButtonProps.onPress, children: _jsx(XIcon, {}) })) : null));
}
//# sourceMappingURL=Toast.js.map